import { EMAIL_FROM_LIST_FAILED, EMAIL_FROM_LIST_SUCCESS, EMAIL_STATUS_FAILED, EMAIL_STATUS_LOADING, EMAIL_STATUS_SUCCESS } from "../actions/emailStatus.action"
import { emailStatusTypesInterface } from "../models/emailStatus.interface"


const initialState : emailStatusTypesInterface = {
    loading : false,
    error : false,
    message : "",
    fromEmailList_data : [],
    emailStatus_data : []
}
const emailStatusReducer = (state : emailStatusTypesInterface = initialState , action : any) : emailStatusTypesInterface=>{
    switch (action.type) {
        case EMAIL_STATUS_LOADING:
            return {
                ...state,
                error: false,
                loading: true,
            }
        case EMAIL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                emailStatus_data: action.payload.response.data[0].statuslist,
            }
        case EMAIL_STATUS_FAILED: 
            return {
                ...state,
                loading: false,
                error: true,
                message: action.payload.error.message || "",
            }
        case EMAIL_FROM_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                fromEmailList_data: action.payload.response.data[0].senderlist,
            }
        case EMAIL_FROM_LIST_FAILED:
            return{
                ...state,
                loading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export default emailStatusReducer;